var _ = require('underscore');
module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div id="customSchemaModelList_empty"> <div id="customSchemaModelListItem"></div> </div>';
}
return __p;
};
